import { createRoute, Outlet, redirect, type AnyRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import type { AccountInfo } from '@azure/msal-browser';
import { AppShell, type Zone } from '@hana/shell';
import { zone as box } from '@hana/zone-box';
import { zone as edu } from '@hana/zone-edu';
import { zone as ezy } from '@hana/zone-ezy';
import { isKitAdmin, kitRedirect, viewerCode, zone as kit } from '@hana/zone-kit';
import { zone as mee } from '@hana/zone-mee';
import { zone as mov } from '@hana/zone-mov';
import { currentAccount, signOut } from './auth';

/** Các vùng gắn vào Hub. Vùng mới: thêm package zones/<vùng> rồi thêm vào đây. */
export const ZONES: Zone[] = [ezy, mee, mov, box, edu, kit];

function ZoneLayout({ zone }: { zone: Zone }) {
  const [me, setMe] = useState<AccountInfo | null>(null);
  useEffect(() => void currentAccount().then(setMe), []);
  return (
    <AppShell zone={zone} user={{ name: me?.name ?? '', email: me?.username ?? '', admin: isKitAdmin(viewerCode(me?.username)) }} onSignOut={() => void signOut()}>
      <Outlet />
    </AppShell>
  );
}

/** /<vùng> — chưa đăng nhập thì về trang đăng nhập Hub, xong quay lại đúng vùng. */
export function zoneRoutes(root: AnyRoute): AnyRoute[] {
  return ZONES.map((z) => {
    const r = createRoute({
      getParentRoute: () => root,
      path: `/${z.key}`,
      beforeLoad: async ({ location }) => {
        if (!(await currentAccount())) throw redirect({ to: '/', search: { ret: z.key } });
        // route quản trị cũ của Ezy → HANA Kit (zones/kit/src/legacy.ts)
        const to = kitRedirect(location.pathname);
        if (to) throw redirect({ to, replace: true } as never);
      },
      component: () => <ZoneLayout zone={z} />,
    });
    return r.addChildren(z.routes(r));
  });
}
